import React, { FC, useContext } from 'react'
import Button from '@bt-react/components/Button';
import classnames from 'classnames';
import Section from '../Section';
import scrollIntoView from 'scroll-into-view-if-needed';
import { PlayerStateContext } from '../../contexts/PlayerStateContext';
import { FastPassContext } from '../../contexts/FastPassContext';
import style from './RegisterMobileButton.module.scss';

const RegisterMobileButton: FC = () => {

  const { registrationState } = useContext(PlayerStateContext)
  const { isFastPassLogin } = useContext(FastPassContext)

  const handleScrollRegistration = () => {

    const eleId = isFastPassLogin ? '[data-bdd=fast-pass-login]' : 'globalauth-helpercomponent';

    const ele = document.querySelector(eleId)
    if (!ele) return
    scrollIntoView(ele, {
      behavior: 'smooth'
    })

  }

  if (registrationState === 'ready' || registrationState === 'registrationComplete') return null

  return <Section size='30' dataBdd='btn-reg-for-free'>
    <Button className={classnames(style['Button'], style['reg-for-free-mobile-button'])} onClick={handleScrollRegistration} block={true}>
      Register for free
    </Button>
  </Section>

}

export default RegisterMobileButton
